import { Component, OnInit } from '@angular/core';
import { ValidacionsesionService } from './validacionsesion.service';

@Component({
  selector: 'app-validacionsesion',
  templateUrl: './validacionsesion.component.html',
  styleUrls: ['./validacionsesion.component.scss']
})
export class ValidacionsesionComponent implements OnInit {


  constructor(public sessionService: ValidacionsesionService) { 

  }

  ngOnInit() {
  }

  checkSession() {
    if (this.sessionService.isSessionActive()) {
      // Mostrar advertencia al usuario y opción para cerrar sesión
      if (confirm('Ya tienes una sesión activa. ¿Deseas desactivarla y continuar?')) {
        this.sessionService.clearSession();
        // Redirigir al usuario a la pantalla de inicio de sesión
        window.location.href = '/login';
      }
    }
  }

}



// import { Component } from '@angular/core';
// import { SessionService } from './services/session.service';

// @Component({
//   selector: 'app-root',
//   templateUrl: './app.component.html',
//   styleUrls: ['./app.component.css']
// })
// export class AppComponent {
//   constructor(private sessionService: SessionService) {}

//   checkSession() {
//     if (this.sessionService.isSessionActive()) {
//       // Mostrar advertencia al usuario y opción para cerrar sesión
//       if (confirm('Ya tienes una sesión activa. ¿Deseas desactivarla y continuar?')) {
//         this.sessionService.clearSession();
//         // Redirigir al usuario a la pantalla de inicio de sesión
//         window.location.href = '/login';
//       }
//     }
//   }



